import { constants } from '../../../common/constants/constants';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoader, showLoader } from '../../../store/common/slice';
import ServerData from '../../../common/serverData';
import { paymentsCardType } from './PaymentPageLogic';
import { StyledTenantRecordConfirmModal } from './TenantRecordConfirmModal.styled';
import { Modal } from 'react-bootstrap';

export function TenantRecordConfirmModal({ type, onClose, buildingID, apartmentNumber }) {
    const [body, setBody] = useState({});

    const dispatch = useDispatch();
    const client = new ServerData();
    const { t } = useTranslation();

    const specialSelected = useSelector(state => state.tenant.oneTimeSelectedPayments);
    const onGoingSelected = useSelector(state => state.tenant.onGoingSelectedPayments);
    const pastSelected = useSelector(state => state.tenant.debtSelectedPayments);
    const tenantDetails = useSelector(state => state.tenant.createPaymentPlanPayload.tenant_details);
    const installments = useSelector(state => state.tenant.installments);

    const noSelectedMonthlyPayments = type === paymentsCardType.monthly && !onGoingSelected.length && !pastSelected.length;
    const noSelectedSpecialPayments = type === paymentsCardType.special && !specialSelected.length;

    useEffect(() => {
        setBody(getBody());
    }, [type]);

    const getBody = () => {
        if (noSelectedMonthlyPayments || noSelectedSpecialPayments) {
            NotificationManager.warning(t('payments.no_payments_selected'));
            return;
        }

        const payingFor = {
            bankAutoCharge: false,
            isChargeCart: false,
            tenant_details: tenantDetails,
        };

        const amount = {
            value: 0,
            currency: null,
        };

        if (type === paymentsCardType.monthly && onGoingSelected.length) {
            payingFor.on_going_payments = {
                number_of_installments: installments.onGoing,
                months: onGoingSelected.map(item => ({
                    month: +item.month,
                    year: +item.year,
                }))
            };

            const total = onGoingSelected.reduce((acc, item) => acc + item.amount_left.value, 0);
            amount.value += total;
            amount.currency = amount.currency || onGoingSelected[0].total.currency;
        }

        if (type === paymentsCardType.monthly && pastSelected.length) {
            payingFor.past_payments = {
                number_of_installments: installments.debts,
                months: pastSelected.map(item => ({
                    month: +item.month,
                    year: +item.year,
                }))
            };

            const total = pastSelected.reduce((acc, item) => acc + item.amount_left.value, 0);
            amount.value += total;
            amount.currency = amount.currency || pastSelected[0].total.currency;
        }

        if (type === paymentsCardType.special && specialSelected.length) {
            payingFor.one_time_payments = specialSelected.map((item) => ({
                number_of_installments: 1,
                building_one_time_payment_id: item.building_one_time_payment_id,
            }))

            const total = specialSelected.reduce((acc, item) => acc + item.amount_left.value, 0);
            amount.value += total;
            amount.currency = amount.currency || specialSelected[0].total.currency;
        }

        const tenantRecord = [
            {
                amount,
                extraDetails: null,
                dueDate: new Date(),
                paymentMethod: constants.managerPaymentsOptions.tenantRecordKey,
            }
        ];

        return {
            apartmentNumber,
            buildingID,
            totalToPay: amount.value,
            paying_for: payingFor,
            tenant_details: tenantDetails,
            tenantRecord,
        };
    };

    const markAsPaid = async () => {
        try {
            dispatch(showLoader());
            await client.post(`/tenants/external-payments/tenant-record/${buildingID}/${apartmentNumber}`, body);
            NotificationManager.success(t('payments.success'));
            onClose(true);
        } catch (e) {
            NotificationManager.error(e.message);
        } finally {
            dispatch(hideLoader());
        }

    }

    if (noSelectedMonthlyPayments || noSelectedSpecialPayments) {
        onClose(false);
    }

    return (
        <StyledTenantRecordConfirmModal centered show={true} onHide={() => onClose(false)}>
            <span className="modal-close" onClick={() => onClose(false)}>&#215;</span>
            <Modal.Header>
                <Modal.Title>{t('offline_payments.pay_with_tenant_record')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="content">
                    <p>{t('offline_payments.tenant_record_modal_text')}</p>
                </div>
                <div className="buttons">
                    <button onClick={markAsPaid} className="bllink-button">{t('offline_payments.approve')}</button>
                </div>
            </Modal.Body>
        </StyledTenantRecordConfirmModal>
    )
}
